import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { login as apiLogin, getUserInfo as apiGetUserInfo } from '@/api'
import { STORAGE_KEYS } from '@/constants'
import type { User } from '@/types'

export const useAuthStore = defineStore('auth', () => {
	const user = ref<User | null>(null)
	const token = ref<string | null>(localStorage.getItem(STORAGE_KEYS.TOKEN))

	const isLoggedIn = computed(() => !!token.value)

	async function login(phone: string, code: string) {
		const data = await apiLogin(phone, code)
		const accessToken = data.token
		token.value = accessToken
		user.value = data as unknown as User
		localStorage.setItem(STORAGE_KEYS.TOKEN, accessToken)
		return data
	}

	async function fetchUser() {
		const data = await apiGetUserInfo()
		user.value = data
		return user.value
	}

	function logout() {
		user.value = null
		token.value = null
		localStorage.removeItem(STORAGE_KEYS.TOKEN)
	}

	return {
		user,
		token,
		isLoggedIn,
		login,
		fetchUser,
		logout,
	}
})
